
export * from './footer';
export * from './header';
export * from './menu';

import { FooterComponent } from './footer'
import { HeaderComponent } from './header';
import { MenuComponent } from './menu';

export const LayoutOrganisms = [
    FooterComponent,
    HeaderComponent,
    MenuComponent
]